import { Directive, HostListener, Input, AfterViewChecked } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { hostElement } from '@angular/core/src/render3/instructions';

@Directive({
  selector: '[appNgSelectIsOpen]'
})
export class NgSelectIsOpenDirective implements AfterViewChecked {

  @Input() appNgSelectIsOpen = true;

  constructor(
    private host: NgSelectComponent
  ) {
    host.elementRef.nativeElement.classList.add('no-dropdown');
  }

  ngAfterViewChecked() {
    if (this.host.elementRef.nativeElement.classList.contains('ng-select-opened')) {
      this.host.elementRef.nativeElement.classList.remove('ng-select-opened');
    }
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/directives/ng-select-is-open.directive.ts